<div class="component-container">
  <div
    class="row w-full flex flex-col md:flex-row md:space-x-[2rem] justify-center items-center">
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['orgType']"
      [options]="orgTypeList"
      [parentFormGroup]="form"
      class="input md:w-[25%] min-w-[25%] w-full"
      controlName="orgType"
      label="Organization Type"
      placeholder="Select all that apply"
      type="small"
    />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['status']"
      [options]="clinicStatusList"
      [parentFormGroup]="form"
      class="input md:w-[25%] min-w-[25%] w-full"
      controlName="status"
      label="Status"
      placeholder="Select all that apply"
      type="small"
    />

    <div class="vertical hidden md:block"></div>

    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      (handleSuffixClick)="apply()"
      [error]="errorMessages['search']"
      [minLength]="0"
      [parentFormGroup]="form"
      class="input w-full md:w-[25%] min-w-[25%] search-input"
      controlName="search"
      label="Search"
      placeholder="Organization Name"
      suffixIcon="search"
      type="small"
    ></app-text-input>

    <div class="vertical hidden md:block"></div>

    <app-primary-button
      (handleClick)="apply()"
      [isDisabled]="!form.dirty"
      class="btn lg:w-[10%] md:w-[10%] w-full"
      type="small"
    >
      Apply
    </app-primary-button>
  </div>
</div>
